module.exports = __webpack_public_path__ + "img/Logo_France_Soir.63b15d53.jpg";